module.exports = __webpack_public_path__ + "img/icon_case_fujian.a4ffa378.png";